import { render } from "./ExtraQuestionInputBox.vue?vue&type=template&id=dd91ab68&scoped=true"
import script from "./ExtraQuestionInputBox.vue?vue&type=script&lang=js"
export * from "./ExtraQuestionInputBox.vue?vue&type=script&lang=js"

import "./ExtraQuestionInputBox.vue?vue&type=style&index=0&id=dd91ab68&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-dd91ab68"]])

export default __exports__